import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DialogBoxService } from '../../../../../custom-shared/components/alerts/dialog-box-service';
const BASE_PATH = environment.basePath;

interface Profile {
  id: string;
}
interface User {
  user_id: string;
  profile: Profile;
}

@Injectable({
  providedIn: 'root',
})
export class MasterUsersProfileService {
  constructor(private _$http: HttpClient) {}

  getUsers(): Promise<any> {
    return this._$http
      .get(`${BASE_PATH}/bff/master/access-profile/users/list`)
      .toPromise();
  }
  getUsersAll() {
    return this._$http
      .get<any>(`${BASE_PATH}/bff/master/get-view-profiles/users/list`)
      .toPromise();
  }
  editUserProfile(users: Array<User>) {
    return this._$http
      .put(`${BASE_PATH}/bff/master/access-profile/users/edit`, users)
      .toPromise();
  }

  confirmOverrideProfile(users: Array<User>) {
    return this._$http
      .put(`${BASE_PATH}/bff/master/access-profile/users/edit/confirm`, users)
      .toPromise();
  }
}
